// Libraries
var React = require('react');

// Styles
require('./Checkbox.scss');

class CheckboxModule extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			label: this.props.checked ? this.props.labelChecked : this.props.labelUnchecked,
		};
	}

	fadeLabel = (value) => {
		if (this.label) {
			this.label.style.opacity = 0;

			setTimeout(() => {
				this.setState({ label: value });
				if (this.label) {
					this.label.style.opacity = 1;
				}
			}, 250);
		}
	}

	toggleCheckbox = () => {
		const { callback, checked } = this.props;
		callback(!checked);
	}

	handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			const checkboxInput = document.getElementById(this.props.id);
			if (checkboxInput) {
			  checkboxInput.click();
			}
		}
	}

	render() {
		if (this.props.checked) {
			this.fadeLabel(this.props.labelChecked);
		} else {
			this.fadeLabel(this.props.labelUnchecked);
		}

		return (
			<div className={"Checkbox" + (this.props.background === "dark" ? " Checkbox--dark" : "") + (this.props.position === "right" ? " Checkbox--right" : "")}>
				<label htmlFor={this.props.id} className="Checkbox__label js-transition" ref={label => this.label = label}>{this.state.label}</label>
				<input onChange={this.props.callback} tabIndex={this.props.tabIndex} checked={this.props.checked} type="checkbox" name="toggle" id={this.props.id} />
				<div className='tick-container'  onClick={this.toggleCheckbox} onKeyDown={this.handleKeyDown} role="checkbox" aria-checked={this.props.checked} tabIndex="0">
					<span className="tick"></span>
				</div>
				{this.props.children}
			</div>
		)
	}
}

module.exports = CheckboxModule;



// WEBPACK FOOTER //
// ./src/common/Checkbox/CheckboxModule.js